import * as React from "react";
import './_style.scss';

// Language
import { useTranslation } from 'react-i18next';


const LoadingFrame = ( props ) => {
  const { t } = useTranslation();

  // set atom class
  const atomClassName = 'loading-frame';
  var atomClass = props.className !== undefined ? atomClassName + ' ' + props.className : atomClassName;

  return (
    <div { ...props }  className={ atomClass }>
      <div className="spinner-grow text-secondary">
        <span className="visually-hidden">{t('Loading...')}</span>
      </div>
    </div>
  )
}

export default LoadingFrame
